import { render, staticRenderFns } from "./DownloadPPMReports.vue?vue&type=template&id=bf43f6e6&"
import script from "./DownloadPPMReports.vue?vue&type=script&lang=ts&"
export * from "./DownloadPPMReports.vue?vue&type=script&lang=ts&"
import style0 from "./DownloadPPMReports.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DownloadPPMReports.vue"
export default component.exports